import { User, FolderKanban, Users, Building2 } from "lucide-react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SCOPE_CONFIG = {
  individual: {
    label: "Individual", icon: User,
    badge: "bg-slate-100 text-slate-700 border-slate-200",
    dot: "bg-slate-400",
  },
  project: {
    label: "Project", icon: FolderKanban,
    badge: "bg-emerald-50 text-emerald-700 border-emerald-200",
    dot: "bg-emerald-500",
  },
  team: {
    label: "Team", icon: Users,
    badge: "bg-indigo-50 text-indigo-700 border-indigo-200",
    dot: "bg-indigo-500",
  },
  organization: {
    label: "Organization", icon: Building2,
    badge: "bg-amber-50 text-amber-700 border-amber-200",
    dot: "bg-amber-500",
  },
};

export const SCOPE_ORDER = ["individual", "project", "team", "organization"];

export const VERTICALS = [
  { value: "general", label: "General" },
  { value: "haven", label: "HAVEN / Real Estate" },
  { value: "grant", label: "Grants" },
  { value: "licensing", label: "Licensing" },
  { value: "brand", label: "Brand" },
  { value: "retail", label: "Retail" },
  { value: "pharma", label: "Pharmaceutical" },
  { value: "pe", label: "Private Equity" },
];

export const CONTENT_TYPES = [
  { value: "text", label: "Text" },
  { value: "insight", label: "Insight" },
  { value: "preference", label: "Preference" },
  { value: "procedure", label: "Procedure" },
  { value: "report", label: "Report" },
  { value: "table", label: "Table" },
  { value: "structured_data", label: "Structured Data" },
];

export const SOURCE_TYPE_LABEL = {
  task_output: "Task Output",
  manual_upload: "Manual",
  external_sync: "External Sync",
  conversation: "Conversation",
  promoted: "Promoted",
};

export function verticalLabel(v) {
  return (VERTICALS.find((x) => x.value === v) || { label: v || "General" }).label;
}
